export default class Calendar {
  originalId!: string | null;
  id!: string | null;
  name!: string | null;
  description!: string | null;
  colorHex!: string | null;
  ownerId!: string | null;
  isDefault!: boolean | null;
  isShared!: boolean | null;
  shareAccess!: string | null;
  canBeShared!: boolean | null;
  privileges!: string[] | null;
  sharedTo!: any[] | null;
  backend!: string | null;
  syncTag!: string | null;
  order!: number | null;
  supportedItems!: string[] | null;
  projects!: string[] | null;

  constructor() {
    this.originalId = null;
    this.id = null;
    this.name = null;
    this.description = null;
    this.colorHex = null;
    this.ownerId = null;
    this.isDefault = null;
    this.isShared = null;
    this.shareAccess = null;
    this.canBeShared = null;
    this.privileges = null;
    this.sharedTo = null;
    this.backend = null;
    this.syncTag = null;
    this.order = null;
    this.supportedItems = null;
    this.projects = null;
  }
}
